<template>
  <q-dialog
    id="dialog-comp"
    v-model="modalOpen"
    persistent
    :position="position"
  >
    <q-card :class="{ column: true, 'full-height': fullHeight }" :style="style">
      <q-toolbar class="q-px-md">
        <!-- TODO make title sticky !-->
        <q-toolbar-title>
          <span class="text-h6 text-primary">{{ modalTitle }}</span>
        </q-toolbar-title>
      </q-toolbar>
      <q-separator />
      <q-card-section id="contact-card-section" class="col full-height">
        <slot class="text-body1" name="content">
          <span v-if="modalText">
            {{ modalText }}
          </span>
          <slot name="htmlContent" />
        </slot>
      </q-card-section>
      <q-separator />
      <div id="modal-footer">
        <q-card-actions align="right">
          <q-btn
            color="primary"
            :disable="actionButtonDisabled"
            :icon="actionButtonIcon"
            :label="actionButtonLabel"
            type="submit"
            @click="confirmClicked"
          />
          <q-btn
            v-if="!noCancelButton"
            color="white"
            :label="cancelButtonLabel"
            text-color="primary"
            type="reset"
            @click="cancelClicked"
          />
        </q-card-actions>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "DialogComp",
  props: {
    actionButtonLabel: {
      type: String,
      default: "Confirm",
    },
    actionButtonDisabled: {
      type: Boolean,
      default: false,
    },
    actionButtonIcon: {
      type: String,
      default: undefined,
    },
    noCancelButton: {
      type: Boolean,
      default: false,
    },
    cancelButtonLabel: {
      type: String,
      default: "Cancel",
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    modalText: {
      type: String,
      default: "",
    },
    modalTitle: {
      type: String,
      default: "Confirm",
    },
    width: {
      type: String,
      default: "unset",
    },
    maxWidth: {
      type: String,
      default: "unset",
    },
    maxHeight: {
      type: String,
      default: "unset",
    },
    height: {
      type: String,
      default: "unset",
    },
    suppressCloseOnActionButtonClick: {
      type: Boolean,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: "standard",
    },
  },
  emits: ["update:modelValue", "cancelClicked", "confirmClicked"],
  setup(props, { emit }) {
    const modalOpen = ref(false);

    watch(
      () => props.modelValue,
      (newVal) => (modalOpen.value = newVal)
    );

    watch(
      () => modalOpen.value,
      (newVal) => emit("update:modelValue", newVal)
    );

    const style = computed(() => {
      return {
        width: props.width,
        "max-width": props.maxWidth,
        height: props.height,
        "max-height": props.maxHeight,
      };
    });

    function closeModal() {
      modalOpen.value = false;
    }

    function confirmClicked() {
      if (!props.suppressCloseOnActionButtonClick) {
        closeModal();
      }
      emit("confirmClicked");
    }

    function cancelClicked() {
      closeModal();
      emit("cancelClicked");
    }

    return {
      modalOpen,
      style,
      confirmClicked,
      cancelClicked,
    };
  },
});
</script>

<style lang="scss">
#dialog-comp {
  #contact-card-section {
    overflow-y: auto;
  }

  #modal-footer {
    position: sticky;
    bottom: 0;
    width: 100%;
    background-color: white;
  }

  .q-card__actions {
    padding: 16px;
  }

  .q-card__actions--horiz > .q-btn-item + .q-btn-item,
  .q-card__actions--horiz > .q-btn-group + .q-btn-item,
  .q-card__actions--horiz > .q-btn-item + .q-btn-group {
    margin-left: 16px;
  }

  .q-card__actions .q-btn {
    padding: 0 16px;
  }
}
</style>
